export function getCachedImage(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const cachedImage = localStorage.getItem(url);
        if (cachedImage) {
            resolve(cachedImage);
        } else {
            fetch(url)
                .then((response) => response.blob())
                .then((blob) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        const base64Data = reader.result as string;
                        localStorage.setItem(url, base64Data);
                        resolve(base64Data);
                    };
                    reader.readAsDataURL(blob);
                })
                .catch(reject);
        }
    });
}
